import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const channelAPI = createApi({
    reducerPath: 'channelAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //** Delete API */
        delete: builder.mutation({
            query: (id) => ({
                url: `/Channel/DeleteChannel/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getChannel: builder.mutation({
            query: (userQuery) => ({
                url: '/Channel/GetChannelList',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),


        getById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/Channel/GetChannelById/?id=${Number(id)}`),
                method: 'GET',
            }),
            providesTags: ['Channel'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  Update API */
        update: builder.mutation({
            query: (Details) => ({
                url: '/Channel/UpdateChannel',
                method: 'POST',
                body: transformRequest(Details)
            }),
            invalidatesTags: ['Channel'],
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Add  API */ 
        add: builder.mutation({
            query: (Details) => ({
                url: '/Channel/AddChannel',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllChannel: builder.query({
            query: () => ({
                url: encryptQueryString(`/Channel/GetAllChannel`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

export const { useGetChannelMutation,
    useLazyGetByIdQuery,
    useDeleteMutation,
    useAddMutation,
    useUpdateMutation,
    useLazyGetAllChannelQuery } = channelAPI;

export default channelAPI;